import { QueryClient } from '@tanstack/react-query'
import { ApiError, NetworkError } from '@/lib/api/problem'

const maxRetries = 2

const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (failureCount >= maxRetries) {
    return false
  }

  if (error instanceof NetworkError) {
    return true
  }

  if (error instanceof ApiError) {
    return error.isRetryable
  }

  return false
}

export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 300_000,
        retry: shouldRetry,
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
        refetchOnWindowFocus: false,
        throwOnError: false,
      },
      mutations: {
        retry: false,
      },
    },
  })

export const pollWhile =
  <T>(isPending: (data: T | undefined) => boolean) =>
  (query: { state: { data: T | undefined } }): number | false => {
    if (typeof document !== 'undefined' && document.hidden) {
      return false
    }

    return isPending(query.state.data) ? 5000 : false
  }
